import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';
  currentYear: number = 2019;

  constructor() {
    this.currentYear = (new Date()).getFullYear();
  }

}
